import { Toast } from 'common/ToastMessage'
import Styles from './ImageMenuModal.module.scss'
import { Spinner } from 'common/Spinner/Spinner'
import { LoadingEllipses } from 'components/Wizards/Wizard/Form/SectionHeader'
import cx from 'classnames'

interface ToastProps {
  percentage?: number
  className?: string
}

export const ProcessingToastMessage = ({ percentage, className }: ToastProps) => {
  const roundedNumber = percentage ? Math.ceil(percentage) : 0

  return (
    <div className={cx(Styles.processingToastMessage, className)}>
      <Toast.Root variant="loading">
        <Toast.Icon variant="loading">
          <Spinner className={Styles.spinner} />
        </Toast.Icon>
        <div className={Styles.description}>
          <div>
            Processing
            <LoadingEllipses />
          </div>
          {percentage !== undefined && <div className={Styles.percentage}>{`${roundedNumber}%`}</div>}
        </div>
      </Toast.Root>
    </div>
  )
}
